module.exports = require('./dist/dev')



//////////////////
// WEBPACK FOOTER
// ./node_modules/lingui-i18n/dev.js
// module id = 1809
// module chunks = 2